import { gql } from '@apollo/client';

export const LIST_EXERCISES = gql`
  query GetAllExercises($page: Int, $limit: Int, $filters: ExerciseFilterInput) {
    getAllExercises(page: $page, limit: $limit, filters: $filters) {
      exercises {
        id
        name
        imageUrl
        videoUrl
        goalId
        description
        subCategoryId
        levelId
        trainingId
        level {
          id
          name
        }
        training {
          id
          name
        }
        length
        trending
        forYou
        tags
        createdAt
        updatedAt
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const CREATE_EXERCISE = gql`
  mutation CreateExercise($input: CreateInput!) {
    createExercise(input: $input) {
      id
      name
      levelId
      length
      trending
      forYou
      tags
      createdAt
      updatedAt
      imageUrl
      videoUrl
      goalId
      subCategoryId
    }
  }
`;

export const UPDATE_EXERCISE = gql`
  mutation UpdateExercise($updateExerciseId: ID!, $input: UpdateInput!) {
    updateExercise(id: $updateExerciseId, input: $input) {
      id
      name
      imageUrl
      videoUrl
      trainingId
      goalId
      subCategoryId
      trainingDay
      levelId
      length
      trending
      forYou
      tags
      createdAt
      updatedAt
    }
  }
`;

export const GET_UNASSIGNED_EXERCISES = gql`
  query GetUnassignedExercises {
    getAllExercises(filters: { trainingId: null }) {
      exercises {
        id
        name
        imageUrl
        videoUrl
        levelId
        level {
          id
          name
        }
        subCategoryId
        goalId
      }
    }
  }
`;

export const GET_TRAINING_EXERCISES = gql`
  query GetTrainingExercises($trainingId: ID!) {
    getAllExercises(filters: { trainingId: $trainingId }) {
      exercises {
        id
        name
        imageUrl
        videoUrl
        trainingDay
        levelId
        level {
          id
          name
        }
        subCategoryId
        goalId
      }
    }
  }
`;

// Removed duplicate declaration

export const DELETE_EXERCISE = gql`
  mutation DeleteExercise($deleteExerciseId: ID!) {
    deleteExercise(id: $deleteExerciseId)
  }
`;

export const LIST_GOALS = gql`
  query ListGoals($page: Int, $limit: Int) {
    listGoals(page: $page, limit: $limit) {
      goals {
        id
        name
        categoryId
        levelId
        createdAt
        updatedAt
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const GET_ALL_SUB_CATEGORIES = gql`
  query GetAllSubCategories {
    getAllSubCategories {
      id
      name
    }
  }
`;

export const GET_ALL_LEVELS = gql`
  query GetAllLevels {
    getAllLevels {
      id
      name
    }
  }
`;
